import React from 'react'
import { useThunkDispatch } from '../../../store';
import { Form } from 'antd';
import { Dayjs } from 'dayjs';
import banlistActions from '../../../store/banlist/actions';
import { FORMAT_DATE_REQUEST } from '../../../store/banlist/constants';
import CustomersTableFilter from './CustomersTableFilter';
import CustomersTableData from './CustomersTableData';

const BanListCustomers = () => {
  const dispatch = useThunkDispatch();
  const [form] = Form.useForm();
  const handleFinish = (values: { endDate: Dayjs, startDate: Dayjs, keyword: string }) => {
    dispatch(banlistActions.customer.fetchList({
      startDate: values.startDate.format(FORMAT_DATE_REQUEST),
      endDate: values.endDate.format(FORMAT_DATE_REQUEST),
      keySearch: values.keyword,
    }))
  };

  return (
    <div>
      <Form form={form} onFinish={handleFinish}>
        <CustomersTableFilter />
      </Form>
      <CustomersTableData />
    </div>
  )
}

export default BanListCustomers;
